import _ from 'lodash';

/**
 * Helpers for keeping the image upload list free of images that could never
 * be saved: uploads that failed, or that finished without an image record.
 */

export function anyImageUploading(images) {
  return _.some(images, (image) => image?.isUploading ?? true);
}

/**
 * Images that must be dropped before the form can be submitted: the failed
 * uploads queued by the upload error handler, plus any image that is no longer
 * uploading but never received an id. Entries removed by the user in the
 * meantime (undefined) are ignored.
 */
export function collectInvalidImages(images, queuedImages = []) {
  return _.uniqBy(
    [
      ...queuedImages,
      ...(images || []).filter(
        (image) => image?.isUploading === false && !image.id
      )
    ].filter(Boolean),
    'file'
  );
}

/**
 * Positions of the given images within the underlying file list, looked up by
 * file identity. Indexes stored on the image objects go stale as soon as any
 * image is removed from the list, so they must never be used for this.
 */
export function findFileIndexes(files, images) {
  return (images || [])
    .map((image) => (files || []).indexOf(image.file))
    .filter((index) => index >= 0);
}

export function findImageIndex(images, file) {
  return (images || []).findIndex((image) => image?.file === file);
}
